function PublicRoute({ children, ...rest }) {
  return (
      children
  );
}

export default PublicRoute;
